// extracted by mini-css-extract-plugin
export default {"header":"Expandable_header__FST-a","chevron":"Expandable_chevron__+bOGB","body":"Expandable_body__j7JpL"};